<template lang="pug">
  t-dialog(
    v-bind="$attrs"
    :value="isOpened"
    v-on="$listeners"
    max-width="900px"
    :hide-overlay="!isVisible"
    :content-class="!isVisible ? 'iit-sign-dialog-hidden' : ''"
    @input="close"
  )
    template(#title) Оберіть ключ касира
    template(#content)
      v-row(class="mt-3 mb-3")
        v-col(cols="12")
          v-overlay(absolute :value="loading")
            e-progress-circular
          m-iit-sign-plugin(
            @keyLoaded="onKeyLoaded"
            @iframeLoading="onIframeLoading"
            ref="plugin"
            :plugin-id="pluginId"
          )
</template>

<script>
import TOrmButtons from '~/components/templates/orm/t-orm-buttons'
import TDialog from '~/components/templates/t-dialog'
import MIitSignPlugin from '~/components/modules/IIT/m-iit-sign-plugin'
import EProgressCircular from '~/components/elements/progress/e-progress-circular'
import Dialog from '~/models/system/Dialog'

export default {
  components: {
    EProgressCircular,
    MIitSignPlugin,
    TOrmButtons,
    TDialog
  },
  props: {
    type: {
      type: String,
      default: 'signAgentDialog'
    },
    pluginId: {
      type: String,
      default: 'signAgentDialog_sign_agent'
    }
  },
  data: () => ({
    loading: false,
    keyLoading: null,
    keyData: null
  }),
  computed: {
    interface () {
      return {
        keyData: this.keyData,
        sign: this.sign
      }
    },
    dialog () {
      return Dialog.query().where('type', this.type).first()
    },
    isOpened () {
      return this._.get(this.dialog, 'isOpened', false)
    },
    isVisible () {
      return this._.get(this.dialog, 'isVisible', false)
    }
  },
  created () {
    Dialog.insert({
      data: {
        type: this.type
      }
    })
  },
  methods: {
    onIframeLoading (loading) {
      this.loading = loading
    },
    async onKeyLoaded (keyData) {
      if (keyData) {
        this.keyData = keyData
        await this.dialog.saveData({
          interface: this.interface
        })
        this.dialog.hide(this.keyData)
      }
    },
    close (data) {
      this.dialog.close(data, true)
    },
    async sign (data) {
      if (this.$refs.plugin) {
        return await this.$refs.plugin.sign(data)
      } else {
        throw new Error('Sign plugin interface not loaded')
      }
    }
  }
}
</script>

<style lang="scss">
  .iit-sign-dialog-hidden {
    display: none !important;
  }
</style>
